let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hulpS")).then(() => parcelRequire('aqH5R'));